//-----------------------------------------------------
// - クリック領域
//-----------------------------------------------------
export function click_area() {
	// $(document).on('click', '[class^="block__card"]:not([class^="block__card_list"]) [class^="elem__list-link"] li', function() {
	// 	if ($(this).find('a').attr('href') !== '') {
	// 		window.location = $(this).find('a').attr('href');
	// 	}
	// });
	// $(document).on('click', '[class^="block__card"]:not([class^="block__card_list"])', function() {
	// 	if ($(this).find('a').attr('href') !== '') {
	// 		window.location = $(this).find('a').attr('href');
	// 	}
	// });
	$(document).on('click', '[class^="block__divide"].--feature .divide_box > div', function() {
		if ($(this).find('a').attr('href') !== '') {
			window.location = $(this).find('a').attr('href');
		}
	});






}